import { observer } from 'mobx-react';
import { useRootStore } from '@nandosaus/state-management';

import { Alert } from '../../alert';
import { Box, Flex } from '../../grid';
import { P } from '../../typography';

const PeriPerks = () => {
  const { CartStore, MemberStore, OrderStore } = useRootStore();

  const pointsBalance = MemberStore?.profile?.balances?.points ?? null;
  const pointsRequired = OrderStore.payableTotal.points;
  const { pointsPaymentDisabledText } = CartStore;

  if (pointsBalance === null) {
    return null;
  }

  const getAlertMessage = () => {
    if (pointsPaymentDisabledText) {
      return pointsPaymentDisabledText;
    }
    if (pointsRequired > pointsBalance) {
      return 'You don’t have enough points to use this payment method. Please use another payment method.';
    }
    return null;
  };

  const alertMessage = getAlertMessage();

  return (
    <>
      {alertMessage && (
        <Box mb={1}>
          <Alert type="error">{alertMessage}</Alert>
        </Box>
      )}

      <Flex flexDirection="column" px={2} py={3} mb={1} borderWidth="1px" borderStyle="solid" borderColor="grey100">
        <Flex justifyContent="space-between">
          <Box width="320px">
            <Flex mb="0.5rem" width="100%" justifyContent="space-between">
              <P fontWeight="bold">Your points balance</P>
              <P>{pointsBalance} points</P>
            </Flex>
            <Flex justifyContent="space-between">
              <P fontWeight="bold">Points required</P>
              <P>{pointsRequired} points</P>
            </Flex>
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

const ComposedPeriPerks = observer(PeriPerks);
export { ComposedPeriPerks as PeriPerks };
